import React, { useState, useEffect, useRef } from "react";
import "../pages/HotelBookingList.css";
import {
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import axios from "axios";
import { useParams } from "react-router-dom";

import {
  getAgentEligibleAmount,
  requestAgentWithdrawal,
  saveGuideBankDetails,
  getGuideWithdrawalStatus,
  getAgentWithdrawalHistory,
} from "../services/guideWithdrawalService";

function AgentTourBookingList() {
  const [bookings, setBookings] = useState([]);
  const [activeTab, setActiveTab] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");

  const [withdrawalSummary, setWithdrawalSummary] = useState({
    eligibleAmount: 0,
    lastAmount: 0,
    status: "Not Available",
    requestedAt: null,
    bankDetailsExist: false,
  });

  const [withdrawalHistory, setWithdrawalHistory] = useState([]);
  const [currentMonthWithdrawal, setCurrentMonthWithdrawal] = useState(0);

  const [showBankForm, setShowBankForm] = useState(false);
  const [bankForm, setBankForm] = useState({
    account_holder_name: "",
    bank_name: "",
    bank_branch: "",
    account_number: "",
    expiry_month: "",
    expiry_year: "",
    cvc: "",
  });

  const sliderRef = useRef(null);

  // const user = JSON.parse(localStorage.getItem("user"));
  // const agentId = user?.id;
  const token = localStorage.getItem("jwt_token");
  const { agentDetailsId, guideId } = useParams();
  const [realGuideId, setRealGuideId] = useState(null);
  const BACKEND_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    if (!agentDetailsId || !guideId) {
      return;
    }

    const fetchRealGuideId = async () => {
      try {
        // Get the real guide ID using the user ID
        const guideIdRes = await axios.get(
          `${BACKEND_URL}/guide/user/${guideId}/guide-id`
        );
        const realGuideId = guideIdRes.data.guideId;
        console.log("Real Guide ID:", realGuideId);
        return realGuideId || null;
      } catch (err) {
        console.error("Error fetching real guide ID:", err);
        return null;
      }
    };

    const loadData = async () => {
      const realGuideId = await fetchRealGuideId();
      if (!realGuideId) return;

      setRealGuideId(realGuideId);

      try {
        // Load bookings
        const bookingRes = await axios.get(
          `${BACKEND_URL}/guides/agent/${agentDetailsId}/guide/${realGuideId}/bookings`
        );
        setBookings(bookingRes.data.bookings || []);

      } catch (err) { }

      try {
        const eligible = await getAgentEligibleAmount(token);
        const status = await getGuideWithdrawalStatus(token);
        const historyRes = await getAgentWithdrawalHistory(token);

        setWithdrawalSummary({
          eligibleAmount: eligible.total || 0,
          lastAmount: status.amount || 0,
          status: status.status || "Not Available",
          requestedAt: status.requestedAt || null,
          bankDetailsExist: false,
        });

        if (historyRes.history) {
          setWithdrawalHistory(historyRes.history);
        }
      } catch (err) { }
    };

    loadData();
  }, [agentDetailsId, token, BACKEND_URL, guideId]);

  useEffect(() => {
    if (realGuideId) {
    }
  }, [realGuideId]);

  useEffect(() => {
    const now = new Date();
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();

    let total = 0;
    withdrawalHistory.forEach((item) => {
      const requestedAt = new Date(item.requestedAt);
      if (
        item.status === "Completed" &&
        requestedAt.getMonth() === currentMonth &&
        requestedAt.getFullYear() === currentYear
      ) {
        total += item.amount;
      }
    });

    setCurrentMonthWithdrawal(total);
  }, [withdrawalHistory]);

  // ---------------- FORMAT & FILTER ----------------
  const formatDate = (date) => new Date(date).toISOString().split("T")[0];
  const today = formatDate(new Date());

  const filterByTab = () => {
    if (activeTab === "today")
      return bookings.filter((b) => formatDate(b.booking_date) === today);

    if (activeTab === "upcoming")
      return bookings.filter((b) => formatDate(b.booking_date) > today);

    if (activeTab === "past")
      return bookings.filter((b) => formatDate(b.booking_date) < today);

    return bookings;
  };

  const filtered = filterByTab().filter((b) =>
    b.tour_listing?.title?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const scroll = (dir) => {
    if (sliderRef.current) {
      const { scrollLeft, clientWidth } = sliderRef.current;
      sliderRef.current.scrollTo({
        left: scrollLeft + (dir === "left" ? -clientWidth : clientWidth),
        behavior: "smooth",
      });
    }
  };

  const handleBankInputChange = (e) => {
    setBankForm({ ...bankForm, [e.target.name]: e.target.value });
  };

  const handleSaveBankDetails = async (e) => {
    e.preventDefault();
    const res = await saveGuideBankDetails(bankForm, token);
    alert(res.message);
    setShowBankForm(false);
  };

  const handleWithdrawalRequest = async () => {
    const res = await requestAgentWithdrawal(token);
    alert(res.message);
  };

  // ---------------- CARD UI ----------------
  const renderCard = (booking) => (
    <div key={booking.id} className="hbl-card">
      <h3 className="hbl-hotel-name">{booking.tour_listing?.title}</h3>

      <div className="hbl-info-row">
        <p>
          <FaCalendarAlt className="hbl-icon" /> <strong>Date:</strong>{" "}
          {new Date(booking.booking_date).toLocaleDateString()}
        </p>
        <p>
          <FaMapMarkerAlt className="hbl-icon" /> <strong>Traveler:</strong>{" "}
          {booking.traveler?.full_name}
        </p>
      </div>

      <div className="hbl-footer">
        <p>
          <strong>Guests:</strong> {booking.numberOfGuests}
        </p>

        <div className="hbl-payment-wrap">
          <span
            className={`hbl-payment-status ${booking.payment_status_id === 1
                ? "paid"
                : booking.payment_status_id === 2
                  ? "pending"
                  : "failed"
              }`}
          >
            {booking.payment_status_id === 1
              ? "Paid"
              : booking.payment_status_id === 2
                ? "Pending"
                : "Failed"}
          </span>

          <p className="hbl-price">Rs. {booking.price}</p>
        </div>
      </div>
    </div>
  );

  return (
    <div className="hbl-container">
      <h2 className="hbl-title">Agent Tour Bookings</h2>

      {/* WITHDRAWAL SUMMARY */}
      <div className="withdraw-card">
        <div className="withdraw-header">
          <h2>Withdrawal Summary</h2>
          <span className="withdraw-status-badge">
            {withdrawalSummary.status}
          </span>
        </div>

        <div className="withdraw-grid">
          <div className="withdraw-item">
            <h4>Bank Details</h4>
            <button
              className="hotel-summary-btn"
              onClick={() => setShowBankForm(true)}
            >
              {withdrawalSummary.bankDetailsExist
                ? "Edit"
                : "Provide Bank Details"}
            </button>
          </div>

          <div className="withdraw-item">
            <h4>Total Withdrawal</h4>
            <p className="amount">Rs. {withdrawalSummary.eligibleAmount}</p>
          </div>

          <div className="withdraw-item">
            <h4>Last Requested</h4>
            <p className="amount">Rs. {withdrawalSummary.lastAmount}</p>
            <span className="date">
              {withdrawalSummary.requestedAt
                ? new Date(withdrawalSummary.requestedAt).toLocaleDateString()
                : "—"}
            </span>
          </div>

          <div className="withdraw-item">
            <h4>Status</h4>
            <p>{withdrawalSummary.status}</p>
          </div>
        </div>

        <button className="view-trans-btn" onClick={handleWithdrawalRequest}>
          Request Withdrawal
        </button>
      </div>

      {/* CURRENT MONTH WITHDRAWAL */}
      <div className="withdraw-card">
        <div className="withdraw-header">
          <h2>Current Month Withdrawal Amount</h2>
        </div>
        <div className="withdraw-grid single-item-grid">
          <div className="withdraw-item">
            <p className="amount" style={{ color: "green" }}>
              Rs. {currentMonthWithdrawal.toFixed(2)}
            </p>
          </div>
        </div>
      </div>

      {/* WITHDRAWAL HISTORY */}
      <div className="withdraw-card">
        <div className="withdraw-header">
          <h2>Withdrawal History</h2>
        </div>
        {withdrawalHistory.length > 0 ? (
          withdrawalHistory.map((item, index) => (
            <div key={index} className="history-item">
              <div className="history-item-row">
                <span>Amount</span>
                <span style={{ color: "#0077FF", fontWeight: "bold" }}>
                  Rs. {item.amount.toFixed(2)}
                </span>
              </div>
              <div className="history-item-row">
                <span>Status</span>
                <span
                  style={{
                    color: item.status === "Completed" ? "green" : "orange",
                    fontWeight: "bold",
                  }}
                >
                  {item.status}
                </span>
              </div>
              <div className="history-item-row">
                <span>Requested</span>
                <span>{new Date(item.requestedAt).toLocaleString()}</span>
              </div>
            </div>
          ))
        ) : (
          <p>No withdrawal history available.</p>
        )}
      </div>

      {/* FILTER TABS */}
      <div className="hbl-tabs">
        {["all", "today", "upcoming", "past"].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`hbl-tab-btn ${activeTab === tab ? "active" : ""}`}
          >
            {tab.toUpperCase()}
          </button>
        ))}
      </div>

      {/* SEARCH */}
      <div className="hbl-search">
        <input
          type="text"
          placeholder="Search for Tour..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {/* SLIDER */}
      <div className="hbl-slider-wrapper">
        <button className="hbl-arrow left" onClick={() => scroll("left")}>
          <FaChevronLeft />
        </button>

        <div className="hbl-slider" ref={sliderRef}>
          {filtered.length ? (
            filtered.map(renderCard)
          ) : (
            <p className="hbl-no-results">No bookings found.</p>
          )}
        </div>

        <button className="hbl-arrow right" onClick={() => scroll("right")}>
          <FaChevronRight />
        </button>
      </div>

      {/* BANK DETAILS MODAL */}
      {showBankForm && (
        <div className="modal-overlay" onClick={() => setShowBankForm(false)}>
          <div className="modal-container" onClick={(e) => e.stopPropagation()}>
            <button
              className="modal-close-btn"
              onClick={() => setShowBankForm(false)}
            >
              &times;
            </button>

            <h2 className="modal-title">Add Bank Details</h2>

            <form onSubmit={handleSaveBankDetails} className="modal-form">
              <div className="modal-input-group">
                <label>ACCOUNT HOLDER NAME</label>
                <input
                  type="text"
                  name="account_holder_name"
                  value={bankForm.account_holder_name}
                  onChange={handleBankInputChange}
                  required
                />
              </div>

              <div className="modal-input-group">
                <label>BANK NAME</label>
                <select
                  name="bank_name"
                  value={bankForm.bank_name}
                  onChange={handleBankInputChange}
                  required
                >
                  <option value="">Select Bank</option>
                  <option value="Bank of Ceylon (BOC)">
                    Bank of Ceylon (BOC)
                  </option>
                  <option value="People's Bank">People's Bank</option>
                  <option value="Commercial Bank">Commercial Bank</option>
                  <option value="Sampath Bank">Sampath Bank</option>
                  <option value="National Savings Bank (NSB)">
                    National Savings Bank (NSB)
                  </option>
                  <option value="Seylan Bank">Seylan Bank</option>
                  <option value="HNB (Hatton National Bank)">
                    HNB (Hatton National Bank)
                  </option>
                  <option value="Regional Development Bank (RDB)">
                    Regional Development Bank (RDB)
                  </option>
                </select>
              </div>

              <div className="modal-input-group">
                <label>BANK BRANCH</label>
                <input
                  type="text"
                  name="bank_branch"
                  value={bankForm.bank_branch}
                  onChange={handleBankInputChange}
                  required
                />
              </div>

              <div className="modal-input-group">
                <label>ACCOUNT NUMBER</label>
                <input
                  type="text"
                  name="account_number"
                  value={bankForm.account_number}
                  onChange={handleBankInputChange}
                  required
                />
              </div>

              {/* <div className="modal-row">
                <input
                  type="number"
                  name="expiry_month"
                  placeholder="Expiry Month"
                  value={bankForm.expiry_month}
                  onChange={handleBankInputChange}
                />
                <input
                  type="number"
                  name="expiry_year"
                  placeholder="Expiry Year"
                  value={bankForm.expiry_year}
                  onChange={handleBankInputChange}
                />
                <input
                  type="number"
                  name="cvc"
                  placeholder="CVC"
                  value={bankForm.cvc}
                  onChange={handleBankInputChange}
                />
              </div> */}

              <button className="modal-submit-btn" type="submit">
                Save Details
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default AgentTourBookingList;
